import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React, { useImperativeHandle } from 'react';

const useStyles = makeStyles(theme => ({
  appMainContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    /* padding: '30px 15px', */
    // padding: 15,
    [theme.breakpoints.up('md')]: {
      paddingLeft: 15,
      paddingRight: 15,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 15,
      paddingRight: 15,
    },
    [theme.breakpoints.up('xl')]: {
      paddingLeft: 15, /* 88 */
      paddingRight: 15, /* 88 */
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 2,
      paddingRight: 2,
    },
  },
}));

const CmtContent = React.forwardRef(function LayoutContent(props, ref) {
  const { children } = props;

  useImperativeHandle(ref, () => ({}));

  const contentRef = React.createRef();
  const classes = useStyles();

  return (
    <Box ref={contentRef} className={clsx(classes.appMainContent, 'Cmt-appMainContent')} bgcolor="background.main">
      {children}
    </Box>
  );
});

export default CmtContent;
CmtContent.defaultProps = {
  name: 'LayoutContent',
};
